import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

export const getAllFinancialYears = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetAllFinancialYears`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch financial years';
    }
};

/** fdrno: pass '0' for the unfiltered full bank list */
export const getBindFDRBanks = async (fdrno = '0') => {
    try {
        const response = await axios.get(`${base}/Reports/BindFDRBanks`, { params: { fdrno } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch bank list';
    }
};

/** BankId: 0 means all banks */
export const getBankFDRNos = async (BankId) => {
    try {
        const response = await axios.get(`${base}/Reports/GetBankFDRNos`, { params: { BankId } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch FD numbers';
    }
};

export const getFDReportDataWithBalance = async ({ FDRNo, Year, Month, Bank }) => {
    try {
        const response = await axios.get(`${base}/Reports/GetFDReportDataWithBalance`, { params: { FDRNo, Year, Month, Bank } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch FD report';
    }
};
